import React from "react";

function FarmAnimalDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="farm-animal-details">
            <h3>Fermə Heyvanı Məlumatları</h3>
            <ul>
                <li><strong>Ad:</strong> {product.name || "Bilinmir"}</li>
                <li><strong>Heyvan növü:</strong> {product.animalType || "Bilinmir"}</li>
                <li><strong>Cins:</strong> {product.breed || "Bilinmir"}</li>
                <li><strong>Yaş:</strong> {product.age ? `${product.age} yaş` : "Bilinmir"}</li>
                <li><strong>Cinsiyyət:</strong> {product.gender || "Bilinmir"}</li>
                <li><strong>Çəki:</strong> {product.weight ? `${product.weight} kq` : "Bilinmir"}</li>
                <li><strong>Süd istehsalı:</strong> {product.milkProduction ? `${product.milkProduction} litr/gün` : "Bilinmir"}</li>
                <li><strong>Sağlamlıq vəziyyəti:</strong> {product.healthStatus || "Bilinmir"}</li>
                <li><strong>Peyvənd olunub:</strong> {product.vaccinated ? "Bəli" : "Xeyr"}</li>
                <li><strong>Şəhər:</strong> {product.city || "Bilinmir"}</li>
                    <li style={{flexDirection:"column"}}>
                    <strong>Əlavə təsvir</strong>
                    <p >
                        {product.description || "Açıqlama mövcud deyil."}
                    </p>
                </li>
            </ul>
        
        </div>
    );
}

export default FarmAnimalDetails;
